import React, { useEffect, useState, useCallback } from 'react';
import Modal from 'react-bootstrap/Modal';
import UserBankAcountModel from '../../models/UserBankAcountModel';
import ComboModel from '../../models/ComboModel';
import AppNotification from '../../helpers/AppNotification';
import Swal from "sweetalert2";

function ModalAcountApp(props) {
    const [users, setUsers] = useState([]);

    const loadUserBanks = useCallback(() => {
        if (!props.userID) return;
        UserBankAcountModel.getAllUserBankAcountForAdmin({
            user_id: props.userID,
        })
        .then((res) => {
            setUsers(res.data || []);
        })
        .catch(err => {
            AppNotification.showError('Lấy dữ liệu thất bại!');
        });
    }, [props.userID]);

    useEffect(() => {
        loadUserBanks();
    }, [loadUserBanks]);

    const handleDeletePackage = (id) => {
        const confirmDelete = window.confirm('Bạn có chắc chắn muốn xóa tài khoản này?');
        if (confirmDelete) {
            UserBankAcountModel.delete(id)
                .then(res => {
                    Swal.fire({
                        icon: "success",
                        title: "Xóa thành công!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    loadUserBanks();
                }).catch(err => {
                    Swal.fire({
                        icon: "error",
                        title: "Xóa thất bại!",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    AppNotification.showError('Xóa thất bại!');
                });
        }
    };

    
    const handleAdminRenew = (bankId, bankLabel, userName, currentEndDay) => {
        Swal.fire({
            title: 'Gia Hạn Tài Khoản Hộ User',
            html: `
                <div style="text-align: left; font-size: 13.5px; color: #cbd5e1; line-height: 1.6;">
                    <div style="background: rgba(255,255,255,0.05); padding: 10px 14px; border-radius: 8px; margin-bottom: 14px; border: 1px solid rgba(255,255,255,0.1);">
                        <div>Tài khoản STK: <b style="color: #38bdf8;">${bankLabel || '---'}</b></div>
                        ${userName ? `<div>User sở hữu: <b style="color: #f59e0b;">${userName}</b></div>` : ''}
                        <div>Hạn hiện tại: <b style="color: #ef4444;">${currentEndDay || 'Chưa thiết lập'}</b></div>
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 8px; color: #f8fafc;">1. Chọn thời gian gia hạn thêm:</label>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 10px;" id="swal-duration-grid">
                        <button type="button" class="swal-plan-btn" data-days="7" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+7 Ngày (1 tuần)</button>
                        <button type="button" class="swal-plan-btn active" data-days="30" style="padding: 9px; border: 2px solid #10b981; background: #064e3b; color: #6ee7b7; border-radius: 6px; font-weight: 600; cursor: pointer; font-size: 13px;">+30 Ngày (1 tháng)</button>
                        <button type="button" class="swal-plan-btn" data-days="90" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+90 Ngày (3 tháng)</button>
                        <button type="button" class="swal-plan-btn" data-days="365" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">+365 Ngày (1 năm)</button>
                        <button type="button" class="swal-plan-btn" data-days="9999" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">Vĩnh viễn (đến 2030)</button>
                        <button type="button" class="swal-plan-btn" data-days="custom" style="padding: 9px; border: 1px solid #475569; background: #1e293b; color: #fff; border-radius: 6px; cursor: pointer; font-size: 13px;">Tuỳ chỉnh số ngày...</button>
                    </div>

                    <div id="swal-custom-days-wrap" style="display: none; margin-bottom: 12px;">
                        <label style="font-size: 12px; color: #94a3b8; display: block; margin-bottom: 4px;">Nhập số ngày muốn cộng thêm:</label>
                        <input type="number" id="swal-custom-days" min="1" max="5000" placeholder="Ví dụ: 15, 60..." style="width: 100%; padding: 8px 10px; background: #0f172a; border: 1px solid #334155; border-radius: 6px; color: #fff; font-size: 13px;" />
                    </div>

                    <label style="display: block; font-weight: 600; margin-bottom: 8px; margin-top: 14px; color: #f8fafc;">2. Hình thức tính phí:</label>
                    <div style="background: rgba(255,255,255,0.03); padding: 10px 12px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.08);">
                        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; margin-bottom: 8px;">
                            <input type="radio" name="swal_fee_type" value="free" checked style="accent-color: #10b981;" />
                            <span><b>Admin tặng / Miễn phí</b> <span style="font-size: 12px; color: #94a3b8;">(Cộng thẳng hạn, không trừ của user)</span></span>
                        </label>
                        <label style="display: flex; align-items: center; gap: 8px; cursor: pointer; margin-bottom: 0;">
                            <input type="radio" name="swal_fee_type" value="combo" style="accent-color: #f59e0b;" />
                            <span><b style="color: #fbbf24;">Trừ Quỹ VIP của User</b> <span style="font-size: 12px; color: #94a3b8;">(Trừ số ngày VIP tương ứng trong ví user)</span></span>
                        </label>
                    </div>
                </div>
            `,
            background: '#111827',
            color: '#f8fafc',
            showCancelButton: true,
            confirmButtonText: 'Xác Nhận Gia Hạn',
            cancelButtonText: 'Đóng',
            confirmButtonColor: '#10b981',
            cancelButtonColor: '#475569',
            didOpen: () => {
                const buttons = document.querySelectorAll('.swal-plan-btn');
                const customWrap = document.getElementById('swal-custom-days-wrap');
                const customInput = document.getElementById('swal-custom-days');

                buttons.forEach(btn => {
                    btn.addEventListener('click', () => {
                        buttons.forEach(b => {
                            b.style.border = '1px solid #475569';
                            b.style.background = '#1e293b';
                            b.style.color = '#fff';
                            b.style.fontWeight = 'normal';
                            b.classList.remove('active');
                        });
                        btn.classList.add('active');
                        btn.style.border = '2px solid #10b981';
                        btn.style.background = '#064e3b';
                        btn.style.color = '#6ee7b7';
                        btn.style.fontWeight = '600';

                        const d = btn.getAttribute('data-days');
                        if (d === 'custom') {
                            customWrap.style.display = 'block';
                            customInput.focus();
                        } else {
                            customWrap.style.display = 'none';
                        }
                    });
                });
            },
            preConfirm: () => {
                const activeBtn = document.querySelector('.swal-plan-btn.active');
                let days = activeBtn ? activeBtn.getAttribute('data-days') : '30';
                if (days === 'custom') {
                    const customVal = parseInt(document.getElementById('swal-custom-days').value, 10);
                    if (!customVal || customVal <= 0) {
                        Swal.showValidationMessage('Vui lòng nhập số ngày hợp lệ!');
                        return false;
                    }
                    days = customVal;
                } else {
                    days = parseInt(days, 10);
                }

                const feeTypeRadio = document.querySelector('input[name="swal_fee_type"]:checked');
                const deductCombo = feeTypeRadio && feeTypeRadio.value === 'combo';

                return { days, deductCombo };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                Swal.fire({
                    title: 'Đang xử lý...',
                    text: 'Hệ thống đang gia hạn và đồng bộ dữ liệu',
                    allowOutsideClick: false,
                    background: '#111827',
                    color: '#fff',
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                ComboModel.adminRenewBankAccount({
                    user_bank_account_id: bankId,
                    days: result.value.days,
                    deduct_combo: result.value.deductCombo ? 1 : 0
                }).then(res => {
                    if (res.success || res.status) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Gia hạn thành công!',
                            text: res.message || 'Tài khoản đã được cập nhật hạn mới thành công!',
                            background: '#111827',
                            color: '#fff',
                            confirmButtonColor: '#10b981'
                        });
                        loadUserBanks();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Thất bại!',
                            text: res.message || 'Có lỗi xảy ra khi gia hạn',
                            background: '#111827',
                            color: '#fff',
                            confirmButtonColor: '#e11d48'
                        });
                    }
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Lỗi!',
                        text: err?.response?.data?.message || err?.message || 'Không thể kết nối đến máy chủ!',
                        background: '#111827',
                        color: '#fff',
                        confirmButtonColor: '#e11d48'
                    });
                });
            }
        });
    };

    const handleResetSingleBank = (bankId, days, bankNumber) => {
        Swal.fire({
            title: `Reset hạn về còn ${days} ngày?`,
            text: `Tài khoản STK: ${bankNumber || bankId} sẽ được đổi ngày hết hạn về còn ${days} ngày kể từ thời điểm này!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Đồng ý (${days} ngày)`,
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#e11d48'
        }).then((result) => {
            if (result.isConfirmed) {
                ComboModel.adminResetBankExpiry({
                    user_bank_account_id: bankId,
                    days: days
                }).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: res.message || `Đã reset về còn ${days} ngày thành công!`,
                        timer: 2500,
                        showConfirmButton: true
                    });
                    loadUserBanks();
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: err.response?.data?.message || 'Reset hạn thất bại!',
                    });
                });
            }
        });
    };

    const handleResetAllBanks = (days) => {
        if (!users.length) {
            Swal.fire({ icon: 'info', title: 'User này chưa có tài khoản App Bank nào!' });
            return;
        }
        Swal.fire({
            title: `Reset TẤT CẢ Bank về còn ${days} ngày?`,
            text: `Toàn bộ ${users.length} tài khoản App Bank của người dùng này sẽ được đổi ngày hết hạn về còn ${days} ngày kể từ thời điểm này!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Xác nhận Reset tất cả (${days} ngày)`,
            cancelButtonText: 'Hủy',
            confirmButtonColor: '#e11d48'
        }).then((result) => {
            if (result.isConfirmed) {
                ComboModel.adminResetUserAllBanksExpiry({
                    user_id: props.userID,
                    days: days
                }).then(res => {
                    Swal.fire({
                        icon: 'success',
                        title: res.message || `Đã reset toàn bộ về còn ${days} ngày thành công!`,
                        timer: 2500,
                        showConfirmButton: true
                    });
                    loadUserBanks();
                }).catch(err => {
                    Swal.fire({
                        icon: 'error',
                        title: err.response?.data?.message || 'Reset thất bại!',
                    });
                });
            }
        });
    };

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Danh sách tài khoản App Bank của User #{props.userID}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Thanh điều khiển Reset hạn sử dụng */}
                <div className="d-flex justify-content-between align-items-center mb-3 p-3 flex-wrap gap-2" style={{ background: 'rgba(239, 68, 68, 0.08)', border: '1px solid rgba(239, 68, 68, 0.25)', borderRadius: '8px' }}>
                    <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: '20px' }}>⏱️</span>
                        <div>
                            <strong style={{ color: '#f87171' }}>Quản lý & Reset hạn sử dụng App Bank:</strong>
                            <div className="text-muted small">Reset nhanh hạn dùng về còn 1 ngày hoặc 3 ngày (áp dụng lẻ từng bank hoặc tất cả bank).</div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <button type="button" className="btn btn-sm btn-danger font-weight-bold" onClick={() => handleResetAllBanks(1)}>
                            ⚡ Reset TẤT CẢ về 1 ngày
                        </button>
                        <button type="button" className="btn btn-sm btn-warning text-dark font-weight-bold" onClick={() => handleResetAllBanks(3)}>
                            ⚡ Reset TẤT CẢ về 3 ngày
                        </button>
                    </div>
                </div>

                <div className="card-body p-0">
                    <div className="table-responsive">
                        <div id="example2_wrapper" className="dataTables_wrapper">
                            <div className="dataTables_scroll">
                                <div
                                    className="dataTables_scrollBody"
                                    style={{
                                        position: "relative",
                                        overflow: "auto",
                                        maxHeight: "52vh",
                                        width: "100%"
                                    }}
                                >
                                    <table
                                        id="example2"
                                        className="display dataTable table table-striped"
                                        style={{ width: "100%" }}
                                        role="grid"
                                    >
                                        <thead>
                                            <tr>
                                                <th className='text-warning' style={{ width: '50px' }}>ID</th>
                                                <th className='text-warning'>Tên</th>
                                                <th className='text-warning'>Số tài khoản</th>
                                                <th className='text-warning'>Ngân hàng</th>
                                                <th className='text-warning'>Gói / Loại</th>
                                                <th className='text-warning'>Hạn sử dụng</th>
                                                <th className='text-warning'>Số dư</th>
                                                <th className='text-warning'>Mã OTP</th>
                                                <th className='text-warning' style={{ minWidth: '180px' }}>Thao tác</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users.length === 0 ? (
                                                <tr>
                                                    <td colSpan="9" className="text-center py-4 text-muted">
                                                        Người dùng này chưa có tài khoản App Bank nào.
                                                    </td>
                                                </tr>
                                            ) : (
                                                users.map((item, key) => {
                                                    const expiry = item.expired_at || item.account_active_user?.expired_date;
                                                    const isVip = item.is_from_combo == 1;
                                                    return (
                                                        <tr key={key} className="odd" role="row">
                                                            <td className="sorting_1">{item.id}</td>
                                                            <td><strong className="text-white">{item.bank_username}</strong></td>
                                                            <td><span className="text-info">{item.bank_number}</span></td>
                                                            <td><span className="badge badge-secondary">{item.type}</span></td>
                                                            <td>
                                                                {isVip ? (
                                                                    <span className="badge badge-warning text-dark font-weight-bold">👑 VIP Combo</span>
                                                                ) : (
                                                                    <span className="badge badge-dark">Thường</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {expiry ? (
                                                                    <span style={{ color: '#38bdf8', fontSize: '13px', fontWeight: 600 }}>
                                                                        {expiry}
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-muted small">Chưa thiết lập</span>
                                                                )}
                                                            </td>
                                                            <td>{item.account_balance_fm} VNĐ</td>
                                                            <td>{item.password_level_two}</td>
                                                            <td>
                                                                <div className="d-flex gap-1 flex-wrap align-items-center">
                                                                    <button 
                                                                        type='button' 
                                                                        onClick={() => handleResetSingleBank(item.id, 1, item.bank_number)} 
                                                                        className="btn btn-xs btn-danger"
                                                                        title="Reset hạn về còn 1 ngày"
                                                                    >
                                                                        1 Ngày
                                                                    </button>
                                                                    <button 
                                                                        type='button' 
                                                                        onClick={() => handleResetSingleBank(item.id, 3, item.bank_number)} 
                                                                        className="btn btn-xs btn-warning text-dark"
                                                                        title="Reset hạn về còn 3 ngày"
                                                                    >
                                                                        3 Ngày
                                                                    </button>
                                                                    <button 
                                                                        type='button' 
                                                                        onClick={() => handleAdminRenew(item.id, item.bank_number, props.user?.user_name, expiry)} 
                                                                        className="btn btn-xs btn-success"
                                                                        title="Gia hạn thời hạn tài khoản hộ user"
                                                                        style={{ fontWeight: 600 }}
                                                                    >
                                                                        + Gia hạn
                                                                    </button>
                                                                    <button 
                                                                        type='button' 
                                                                        onClick={() => handleDeletePackage(item.id)} 
                                                                        className="btn btn-xs btn-outline-danger"
                                                                        title="Xóa vĩnh viễn tài khoản"
                                                                    >
                                                                        Xóa
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={props.onHide}>
                        Đóng
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ModalAcountApp;